export default __webpack_public_path__ + "static/media/bg-user-detail.d3ea4c6d.png";